import React from "react";
import { Star, Users, Truck, ShieldCheck } from "lucide-react";

const STATS = [
  { icon: Star, value: "4,9/5", label: "Note moyenne clientes" },
  { icon: Users, value: "+1 100", label: "Avis clients vérifiés" },
  { icon: ShieldCheck, value: "15 ans", label: "Marque française experte" },
  { icon: Truck, value: "Offerte", label: "Livraison suivie" },
];

export const SocialProof = () => (
  <section className="bg-[var(--oz-dark)] text-white" data-testid="social-proof">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-8 md:py-10">
      <div className="flex items-center justify-center gap-1 mb-6">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} className="w-4 h-4 text-[var(--oz-gold)] fill-[var(--oz-gold)]" />
        ))}
        <span className="ml-2 text-sm text-white/70">Ils nous font confiance</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        {STATS.map((s) => (
          <div key={s.label} className="text-center" data-testid={`stat-${s.value}`}>
            <s.icon className="w-6 h-6 text-[var(--oz-gold)] mx-auto mb-2" />
            <div className="font-serif text-2xl md:text-3xl text-white">{s.value}</div>
            <div className="text-xs text-white/60 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof;
